import React from 'react';
import i18n from '@i18n';

const BlockLoader = ({ textClassName }: { textClassName?: string }) => (
    <div className="blockLoader">
        <p className={textClassName}>{i18n('commons.term.loading')}</p>
        <div className="linear-loader" />
    </div>
);

export default BlockLoader;
